import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';
import { AlertDialogComponent } from '../pages/alert-dialog/alert-dialog.component';
import { DirtyCheck } from '../constants/message-constant';
import { MatDialog } from '@angular/material/dialog';

export interface ComponentCanDeactivate {
  canDeactivate: (event: any) => boolean | Observable<boolean>;
}
@Injectable({
  providedIn: 'root'
})
export class DirtyFormGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(public dialog: MatDialog) {
  }
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component.canDeactivate(event)) {
      return this.confirmChanges();
    }
    return of(true);
  }

  confirmChanges(): Observable<boolean> {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '498px',
      height: '218px',
      position: { top: '30px' },
      data: {
        title: DirtyCheck.TITLE,
        message: DirtyCheck.MESSAGE,
      },
      autoFocus: false,
      disableClose: true
    })
    return dialogRef.afterClosed();
  }
}
